import { api } from '@marketplace-web/core-api/core-api-client-data'

import { BusinessRegistrationDto } from '../types/business-registration'

export const submitBusinessRegistrationDsa = (registration: BusinessRegistrationDto) =>
  api.post('/business_accounts_dsa', registration)

export const validateBusinessRegistrationDsa = (registration: BusinessRegistrationDto) =>
  api.post('/business_accounts_dsa/validate', registration)

export const deleteBusinessRegistration = (userId: number) =>
  api.delete(`/business_accounts/${userId}`)
